import {
  Box,
  Divider,
  Grid,
  IconButton,
  Typography,
  useTheme,
} from "@mui/material";
import DotSeparatedStrings from "../../../../../common/components/functional/dotSeparatedStrings/DotSeparatedStrings";
import InfoTooltip from "../../../../../common/components/functional/InfoTooltip/InfoTooltip";
import { TalentIntroducedToCustomerStatus } from "../../../../talents/types/queries";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { leadingZerosDateFormat } from "../../../../../common/helpers/formatDateTime";
import TalentIntroductionStatus from "./TalentIntroductionStatus";
import { TalentIntroductionRow } from "../../types";
import { MoreVert as MoreIcon } from "@mui/icons-material";
import {
  ACTION_WIDTH,
  CUSTOMER_NAME_WIDTH,
  STATUS_WIDTH,
  TIMESTAMP_WIDTH,
} from "../../constants";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

type Props = {
  row: TalentIntroductionRow;
  index?: number;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  withOrder?: boolean;
};

const TalentIntroducedToCustomerRow = ({
  index,
  row,
  onClick,
  withOrder,
}: Props) => {
  const theme = useTheme();
  const { t } = useTranslation("talentProfile");

  const disabledColor = theme.typography.disabled;

  const isCanceled = row.status === TalentIntroducedToCustomerStatus.Cancelled;
  const colorProp = { color: isCanceled ? disabledColor : "inherit" };
  return (
    <>
      <Grid key={row.introducedAt} container my="5px">
        <Grid item xs={TIMESTAMP_WIDTH}>
          <Box display="flex" alignItems="center" gap="4px">
            <Typography sx={colorProp}>
              {format(new Date(row.introducedAt), leadingZerosDateFormat)}
            </Typography>
            {withOrder && (
              <InfoTooltip
                title={t("profileSummary.orderIntroductionDateTooltip")}
                icon={
                  <InfoOutlinedIcon sx={{ height: "16px", width: "16px" }} />
                }
              />
            )}
          </Box>
        </Grid>
        <Grid item container xs={CUSTOMER_NAME_WIDTH} alignItems="flex-start">
          <Box display="flex" flexDirection="column" alignItems="flex-start">
            <Typography variant="body1" lineHeight="24px">
              {row.customerOrgName}
            </Typography>
            <Typography variant="body2">{row.workLocationName}</Typography>
            <DotSeparatedStrings
              dotSx={{
                backgroundColor: isCanceled ? "#00000061" : "#00000085",
              }}
              list={row.workTitles.map((workTitle) => workTitle.name)}
              TypographyProps={{
                variant: "secondary",
                sx: {
                  fontSize: "14px",
                  color: isCanceled ? disabledColor : "text.secondary",
                },
              }}
            />
          </Box>
        </Grid>
        <Grid
          item
          container
          xs={STATUS_WIDTH}
          justifyContent="flex-start"
          alignItems="flex-start"
        >
          <TalentIntroductionStatus status={row.status} withOrder={withOrder} />
        </Grid>
        {onClick && index !== undefined && (
          <Grid
            item
            container
            xs={ACTION_WIDTH}
            justifyContent="flex-end"
            alignItems="flex-start"
          >
            <IconButton
              id={index.toString()}
              size="small"
              sx={{ marginTop: "-2px" }}
              onClick={onClick}
            >
              <MoreIcon sx={{ width: "18px", height: "18px" }} />
            </IconButton>
          </Grid>
        )}
      </Grid>
      <Divider />
    </>
  );
};

export default TalentIntroducedToCustomerRow;
